import React, { useState } from 'react';

function UnlockClientModal({ open, clientName, onUnlock, onCancel, loading = false, error = '' }) {
  const [passphrase, setPassphrase] = useState('');

  if (!open) {
    return null;
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    await onUnlock(passphrase);
    setPassphrase('');
  };

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.35)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        padding: '1rem',
      }}
    >
      <div className="card" style={{ width: '100%', maxWidth: 520 }}>
        <h3 className="card-title mb-4">Unlock Client</h3>
        <p className="text-sm text-muted mb-4">
          Enter the passphrase for <strong>{clientName || 'this client'}</strong>.
          The key is kept in memory only and auto-locks on idle/logout.
        </p>
        {error ? <div className="badge badge-error mb-4">{error}</div> : null}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Passphrase</label>
            <input
              type="password"
              className="form-input"
              value={passphrase}
              onChange={(e) => setPassphrase(e.target.value)}
              minLength={12}
              required
              autoFocus
            />
          </div>
          <div className="flex gap-2" style={{ marginTop: '1rem' }}>
            <button type="button" className="btn btn-secondary" onClick={onCancel} disabled={loading}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary" disabled={loading || passphrase.length < 12}>
              {loading ? 'Unlocking...' : 'Unlock'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default UnlockClientModal;
